import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Backdrop, CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BannerForm from "../../component/admin/formComponents/BannerForm";
import { getBanner } from "../../api/getBanner";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function Goals() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchBannerData = async (id, token) => {
    try {
      const data = await getBanner(id, token);
      if (data.success) {
        formik.setValues({
          category: data.data.category,
          image: data.data.banner_img,
          previous_months: data.data.prev_month
            ? moment(data.data.prev_month).format("YYYY-MM")
            : moment().format("YYYY-MM"),
          type: data.data.type,
        });
        setLoading(false);
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error("Error while fetching banner data");
    }
  };

  useEffect(() => {
    if (id) {
      fetchBannerData(id, token);
    } else {
      setLoading(false);
      toast.error("Banner ID is missing");
      navigate("/admin/dashboard/banners");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      category: "",
      image: "",
      type: null,
    },
    validationSchema: Yup.object().shape({
      category: Yup.number("Please enter integer value")
        .required("Category is Required")
        .typeError("Category is Required"),
      image: Yup.mixed().required("Banner Image is required"),
      previous_months: Yup.date()
        .typeError("Please select previous months")
        .when("category", {
          is: 6,
          then: (schema) => schema.required("Please Enter Previous Months"),

          otherwise: (schema) => {},
        }),
      type: Yup.string().when("category", {
        is: (value) => [1, 2, 3, 5, 6].includes(value),
        then: (schema) => schema.required("Please select the type"),

        otherwise: (schema) => {},
      }),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("category", values.category);

      data.append("image", values.image);
      data.append("id", id);
      data.append("type", values.type);
      if (values.category == 6) {
        data.append("prev_month", values.previous_months);
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/editBanner`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          // toast.success("test");
          setTimeout(() => {
            navigate("/admin/dashboard/banners");
            setLoading(false);
          }, 1000);
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
        setLoading(false);
      }
    },
  });


  return (
    <React.Fragment>
      <ToastContainer />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Update Banner
          </Typography>
        </Box>

        <BannerForm formik={formik} edited={true} />
      </Box>
    </React.Fragment>
  );
}
